var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function Folder(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 5v14a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-6.3l-1.17-2.342A3 3 0 0 0 9.845 2H4a3 3 0 0 0-3 3zm8.882-1H4a1 1 0 0 0-1 1v1h8.5l-.724-1.447A1 1 0 0 0 9.882 4zM3 19V9a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z", fill: "" })));
}
export var FolderIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: Folder }, props))); };
//# sourceMappingURL=FolderIcon.js.map